import builder from '../builder';
import AdvertisingBillboardHouse from '../../streamline-icons/light/advertising-billboard-house.svg';

export default builder(
  'AdvertisingBillboardHouseLight',
  AdvertisingBillboardHouse,
);
